import { GLOBAL } from 'saddlebag-browser';

/**
 * @param {string} url Base Url
 * @param {object} options Header options
 * @returns {Promise} Response in promise format
 */
const fetch = (url, options) =>
  new Promise((resolve, reject) => {
    GLOBAL.getWindow().fetch(url, options).then(resolve, reject);
  });

export default fetch;
